import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5e86d456")
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "d-flex justify-space-between pa-2 align-center" }
const _hoisted_3 = {
  key: 0,
  class: "mb-2 expansion-content pa-2"
}
const _hoisted_4 = { class: "justify-end d-flex width-full" }
_popScopeId()

import { withDefaults, ref } from 'vue'

interface IProps {
  removeEnrichment?: (index: number) => void
  items?: []
}


export default /*#__PURE__*/_defineComponent({
  props: {
    removeEnrichment: { type: Function, required: false, default: () => ({}) },
    items: { type: Array, required: false, default: () => [] }
  },
  setup(__props: any) {

const props = __props as { removeEnrichment: (index: number) => void, items: [] }


const openPanelId = ref(-1)

const togglePanel = (index: number): void => {
  openPanelId.value = openPanelId.value === index ? -1 : index
}

const isOpen = (index: number): boolean => {
  return openPanelId.value === index
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["my-2 expansion-panel card", isOpen(index) ? 'open' : '']),
        onClick: ($event: any) => (togglePanel(index))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('details.email.enrichment.title')) + " " + _toDisplayString(index + 1), 1),
          _createVNode(_component_v_icon, { class: "activator" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isOpen(index) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        (isOpen(index))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('details.email.enrichment.url.placeholder')) + ": " + _toDisplayString(item.url), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('details.email.enrichment.templateKey.placeholder')) + ": " + _toDisplayString(item.templateKey), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('details.email.enrichment.sourcePropertyPath.placeholder')) + ": " + _toDisplayString(item.sourcePropertyPath), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  small: "",
                  onClick: () => props.removeEnrichment(index)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('actions.delete')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    }), 128))
  ]))
}
}

})